import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface EmailAddressProps {
  band: Band
}

export const EmailAddress: React.FC<EmailAddressProps> = ({ band }) => {
  const fieldData = {
    field: "email",
    name: "bandEmail",
    label: "Email Address",
    placeholder:
      "The official public email address that will be viewable to fans",
    notes: "The official public email that will be viewable to everyone",
    required: false,
  }

  return <EditBandFormField type="text" fieldData={fieldData} />
}
